// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9594cc9d","455":"9bcfd02b","488":"5e53536b","977":"f152060d"}[chunkId] + ".chunk.js";
};